import React, { useState } from 'react';
import { Tabs, Badge } from 'antd';
import { useBadgeContext } from "../../../context/BadgeContext";
import { useDirtyContext } from "../../../context/DirtyContext";
import './InternalOrders.css';
import SystemPlanningOrder from "../systemPlanningOrder/systemPlanningOrderMain/SystemPlanningOrder";
import MeasureOrder from "../measureOrder/measureOrderMain/MeasureOrder";
import ConstructionOrder from "../constructionOrder/constructionOrderMain/ConstructionOrder";
import MaterialReservation from "../materialReservation/materialReservationMain/MaterialReservation";
import ColorReservation from "../colorReservation/colorReservationMain/ColorReservation";

const { TabPane } = Tabs;

const InternalOrders: React.FC = () => {
    const { badgeCounts } = useBadgeContext();
    const { confirmNavigation } = useDirtyContext();

    // Statt Routing: Lokaler Zustand für aktiven Tab
    const [activeTab, setActiveTab] = useState<string>("/measureOrder");

    const renderTab = (title: string, key: string) => (
        <div style={{ position: 'relative', display: 'inline-block', paddingRight: '12px' }}>
            {title}
            {badgeCounts[key] ? (
                <Badge
                    count={badgeCounts[key]}
                    size="small"
                    style={{
                        position: 'absolute',
                        top: '-15px',
                        right: '-12px',
                        fontSize: '10px',
                        height: '14px',
                        minWidth: '14px',
                        lineHeight: '14px',
                        padding: '0 4px'
                    }}
                />
            ) : null}
        </div>
    );

    const handleTabChange = (key: string) => {
        confirmNavigation(() => {
            setActiveTab(key);
        });
    };


    return (
        <div className="internal-orders-container">
            <Tabs
                activeKey={activeTab}
                onChange={handleTabChange}
                tabBarGutter={20}
                tabPosition="top"
                size="small"
                className="internal-orders-tabs"
            >
                <TabPane tab={renderTab("Messbeauftragung", "/measureOrder")} key="/measureOrder">
                    <MeasureOrder />
                </TabPane>
                <TabPane tab={renderTab("Systemplanungsbeauftagung", "/systemPlanningOrder")} key="/systemPlanningOrder">
                    <SystemPlanningOrder />
                </TabPane>
                <TabPane tab={renderTab("Material-Reservation", "/materialReservation")} key="/materialReservation">
                    <MaterialReservation />
                </TabPane>
                <TabPane tab={renderTab("Farb-Reservation", "/colorReservation")} key="/colorReservation">
                    <ColorReservation />
                </TabPane>
                <TabPane tab={renderTab("Konstruktionsbeauftragung", "/constructionOrder")} key="/constructionOrder">
                    <ConstructionOrder />
                </TabPane>
            </Tabs>
        </div>
    );
};

export default InternalOrders;
